/**
 * Subscription tiers — mirrors iOS SubscriptionTier.
 */

export type SubscriptionTier = 'free' | 'basic' | 'premium';

export const SUBSCRIPTION_TIERS: SubscriptionTier[] = ['free', 'basic', 'premium'];

export function parseSubscriptionTier(raw: string | null | undefined): SubscriptionTier | null {
  if (!raw) return null;
  const normalized = raw.trim().toLowerCase();
  if (normalized === 'free' || normalized === 'basic' || normalized === 'premium') {
    return normalized;
  }
  return null;
}

export function tierDisplayName(tier: SubscriptionTier): string {
  switch (tier) {
    case 'free':
      return 'Free';
    case 'basic':
      return 'Basic';
    case 'premium':
      return 'Premium';
  }
}

/** Tier matrix used after trial expires (when enforcement is on). */
export function tierIncludesPlacesImages(tier: SubscriptionTier): boolean {
  return tier === 'basic' || tier === 'premium';
}

export function tierIncludesAIPlan(tier: SubscriptionTier): boolean {
  return tier === 'premium';
}

export function tierIncludesLevel1(tier: SubscriptionTier): boolean {
  return tier === 'basic' || tier === 'premium';
}

export function tierIncludesLevel2(tier: SubscriptionTier): boolean {
  return tier === 'premium';
}
